import { PropsWithChildren, type JSX } from "react";
import { EditableContentWrapper, UserThemableUIElementCaption } from "./EditableUIElement.styles";
import { AuthoryColorSchemes } from "../ProfileHero/V3ProfileHero.types";

interface EditableUIElementProps extends PropsWithChildren {
    hasContent: boolean;
    text?: string;
    onClick?: () => void;
    smallPadding?: boolean;
    customNoContent?: JSX.Element;
    editMode: boolean;
    customBorderRadius?: string;
    colorVariant: AuthoryColorSchemes;
    isInline?: boolean;
    customBackgroundColor?: string;
}

export const EditableUIElement = ({
    hasContent = false,
    text,
    children,
    onClick,
    smallPadding = false,
    customNoContent,
    editMode = false,
    customBorderRadius = "100px",
    colorVariant,
    isInline = true,
    customBackgroundColor
}: EditableUIElementProps) =>
    !editMode ? (
        <>{children}</>
    ) : (
        <EditableContentWrapper
            onClick={onClick}
            $smallPadding={smallPadding}
            $customBorderRadius={customBorderRadius}
            $colorVariant={colorVariant}
            $dashOnHover={editMode}
            $editMode={editMode}
            $isInline={isInline}
            $customBackgroundColor={customBackgroundColor}
            $useBorder
            $hasContent={hasContent}
        >
            {hasContent ? (
                children
            ) : customNoContent ? (
                customNoContent
            ) : (
                <UserThemableUIElementCaption $colorVariant={colorVariant} $customBackgroundColor={customBackgroundColor}>
                    <strong>{text}</strong>
                </UserThemableUIElementCaption>
            )}
        </EditableContentWrapper>
    );
